import { Component, Injector, OnInit, OnDestroy } from '@angular/core';
import { GetTenantPlanInfoDto, HostDashboardServiceProxy, TopStatsData } from '@shared/service-proxies/service-proxies';

import { WidgetComponentBase } from '../widget-component-base';
let jmoment = require('jalali-moment');
import * as jalali_moment from 'jalali-moment';
import * as moment from 'moment';

@Component({
  selector: 'app-widget-host-top-stats',
  templateUrl: './widget-host-top-stats.component.html',
  styleUrls: ['./widget-host-top-stats.component.css']
})
export class WidgetHostTopStatsComponent extends WidgetComponentBase implements OnInit, OnDestroy {

  selectedDateRange: jalali_moment.Moment[] = [jmoment().add(-7, 'days').startOf('day'), jmoment().endOf('day')];
  loading = true;
  topStatsData: TopStatsData;

  serviceInfo: GetTenantPlanInfoDto = new GetTenantPlanInfoDto();

  constructor(
    injector: Injector,
    private _hostDashboardServiceProxy: HostDashboardServiceProxy) {

    super(injector);



  }

  ngOnInit(): void {
    this.subDateRangeFilter();
    this.runDelayed(this.loadHostTopStatsData);
  }

  loadHostTopStatsData = () => {
    let helperDateRange: moment.Moment[] = [];

    helperDateRange[0] = jmoment.from(this.selectedDateRange[0], 'fa', 'YYYY-MM-DDTHH:mm:ss.SSSS');
    helperDateRange[1] = jmoment.from(this.selectedDateRange[1], 'fa', 'YYYY-MM-DDTHH:mm:ss.SSSS');
    this._hostDashboardServiceProxy.getTopStatsData(helperDateRange[0], helperDateRange[1]).subscribe((data) => {
      this.topStatsData = data;
      this.loading = false;
    });
    this._hostDashboardServiceProxy.getTenantData().subscribe(result => {
      this.serviceInfo = result;
    });
  }

  onDateRangeFilterChange = (dateRange) => {

    let helperDateRange: jalali_moment.Moment[] = [];

    helperDateRange[0] = jmoment(dateRange[0]).locale('fa').format('YYYY/MM/DD');
    helperDateRange[1] = jmoment(dateRange[1]).locale('fa').format('YYYY/MM/DD');

    if (!helperDateRange || helperDateRange.length !== 2 || (this.selectedDateRange[0] === helperDateRange[0] && this.selectedDateRange[1] === helperDateRange[1])) {
      return;
    }
    this.selectedDateRange[0] = helperDateRange[0];
    this.selectedDateRange[1] = helperDateRange[1];


    this.runDelayed(this.loadHostTopStatsData);
  }

  subDateRangeFilter() {
    abp.event.on('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  unSubDateRangeFilter() {
    abp.event.off('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  ngOnDestroy(): void {
    this.unSubDateRangeFilter();
  }
}
